var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2116(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116",
    transform: "translate(-1765.78 -144.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M14.763.075A.5.5,0,0,1,15,.5v15a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V14H10v1.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V10a.5.5,0,0,1,.342-.474L6,7.64V4.5a.5.5,0,0,1,.276-.447l8-4a.5.5,0,0,1,.487.022Z",
    transform: "translate(1765.78 144.166)",
    fill: "#2b5f8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M2,11.107H3.011V12.12H2Zm2.021,0H5.032V12.12H4.021ZM2,13.134H3.011v1.013H2Zm2.021,0H5.032v1.013H4.021ZM8.064,9.08H9.075v1.013H8.064Zm2.021,0H11.1v1.013H10.086ZM8.064,11.107H9.075V12.12H8.064Zm2.021,0H11.1V12.12H10.086ZM12.107,9.08h1.011v1.013H12.107Zm0,2.027h1.011V12.12H12.107ZM8.064,7.053H9.075V8.067H8.064Zm2.021,0H11.1V8.067H10.086Zm2.021,0h1.011V8.067H12.107ZM8.064,5.027H9.075V6.04H8.064Zm2.021,0H11.1V6.04H10.086Zm2.021,0h1.011V6.04H12.107Zm0-2.027h1.011V4.013H12.107Z",
    transform: "translate(1765.722 144.078)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2116);
export default __webpack_public_path__ + "static/media/Group 2116.cef2cce3.svg";
export { ForwardRef as ReactComponent };